export default __webpack_public_path__ + "static/media/guide22.ee3eab67.png";